import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../../dropdown'
import config from '../../../../config'

import { AuthGDPR } from '../common/AuthGDPR'
import { AuthResponsable } from '../common/AuthResponsable'
import { AuthEdat17 } from '../common/AuthEdat17'

import { AuthCompromis, AuthCompromisMenors16 } from './AuthCompromis'
import { AuthMobils, AuthMobilsESO } from './AuthMobils'
import { AuthLlibresSocialitzats } from './AuthLlibresSocialitzats'
import { AuthSortides , AuthSortidesMenors } from './AuthSortides'
import { AuthDretsImatge } from './AuthDretsImatge'
import { AuthMedica } from './AuthMedica'
import { AuthAMPA } from './AuthAMPA'
import { AuthAlcohol } from './AuthAlcohol'
import { AuthPagament } from './AuthPagament'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  const [authDretsImatge , setAuthDretsImatge ] = useState();
  const [authSortides, setAuthSortides ] = useState();

  const [authCompromis, setAuthCompromis ] = useState("0");
  const [authGDPR, setAuthGDPR ] = useState("0");
  const [authAMPA, setAuthAMPA ] = useState("0");
  const [authMedica, setAuthMedica ] = useState();
  const [authAlcohol, setAuthAlcohol ] = useState();
  const [authResponsable, setAuthResponsable ] = useState("0");
  const [authMobils, setAuthMobils] = useState("0");
  //const [authPortatils, setAuthPortatils ] = useState("0");
  const [authLlibresSocialitzats, setAuthLlibresSocialitzats ] = useState("0");
  const [authPagament, setAuthPagament] = useState("0");

  //const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const major18 = props.dadesPersonals.edat >= 18 || false
  const major16 = props.dadesPersonals.edat >= 16 || false

  const authAlcoholCriteria = !major18 && ( props.dadesEstudis.curs.id.startsWith("CFPM") || props.dadesEstudis.curs.id.startsWith("CFPS"))
  const authMedicaCriteria = !major18
  const authLlibresSocialitzatsCriteria = props.dadesEstudis.curs.id.startsWith("ESOLOE")


  const handleDadesAutoritzacions = (noError) => {
    let d = {
     "validat": noError,
  
    /* DADES AUTORITZACIONS */
    "authCompromis": authCompromis,
    "authDretsImatge": authDretsImatge,
    "authSortides": authSortides,
    "authAMPA": authAMPA,
    "authResponsable": authResponsable,
    "authMobils": authMobils,
    "authGDPR": authGDPR,
    "authPagament": authPagament
  }
  
  if( authLlibresSocialitzatsCriteria) d.authLlibresSocialitzats = authLlibresSocialitzats
  if( authAlcoholCriteria ) d.authAlcohol = authAlcohol
  if( authMedicaCriteria ) d.authMedica = authMedica

  
    //console.log("DADES_AUTORITZACIONS",d)
    //  setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }

  const validaAuthDretsImatge = () => {
    //només obligatori pels menors de 14
    //if(props.dadesPersonals.edat >= 14 ) return null
    return authDretsImatge ? null : "Heu d'indicar una resposta"
  }

  const validaAuthSortides = () => {
    return authSortides ? null : "Aquest camp és obligatori"
  }

  const validaAuthAlcohol = () => {
    return authAlcohol ? null : "Aquest camp és obligatori"
  }

  const validaAuthMedica = () => {
    return authMedica ? null : "Aquest camp és obligatori"
  }

  const validaAuthCompromis = () => {
    return authCompromis === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthMobils = () => {
    return authMobils === "1" ? null : "Aquest camp és obligatori"
  }

  /*
  const validaAuthPortatils = () => {
    return authPortatils === "1" ? null : "Aquest camp és obligatori"
  }
  */

  const validaAuthLlibresSocialitzats = () => {
    return authLlibresSocialitzats === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthGDPR= () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthResponsable= () => {
    return authResponsable === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthPagament = () => {
    return authPagament === "1" ? null : "Aquest camp és obligatori"
  }





 const handleChangeAuthDretsImatge = (t) => {

      setAuthDretsImatge(t)

      handleDadesAutoritzacions(false)
 }


 const handleChangeCompromis = (t) => {

      setAuthCompromis(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeGDPR = (t) => {

      setAuthGDPR(t === "0" ? "1" : "0") 

      //if(t === "1") handleDadesAutoritzacions(false)
      handleDadesAutoritzacions(false)
 }

 const handleChangeResponsable = (t) => {

      setAuthResponsable(t === "0" ? "1" : "0") 

      //if(t === "1") handleDadesAutoritzacions(false)
      handleDadesAutoritzacions(false)
 }

 const handleChangeMobils = (t) => {

      setAuthMobils(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 /*
 const handleChangePortatils = (t) => {

      setAuthPortatils(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }
*/

 const handleChangeLlibresSocialitzats = (t) => {

      setAuthLlibresSocialitzats(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeSortides = (t) => {

      setAuthSortides(t)

      handleDadesAutoritzacions(false)
 }

 const handleChangeAMPA= (t) => {

      setAuthAMPA(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeAlcohol = (t) => {

      setAuthAlcohol(t)

      handleDadesAutoritzacions(false)
 }

 const handleChangeMedica = (t) => {

      setAuthMedica(t)

      handleDadesAutoritzacions(false)
 }

 const handleChangePagament = (t) => {

      setAuthPagament(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }





/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  error.authCompromis = validaAuthCompromis();
  handleErrors('authCompromis',error)

  error.authMobils = validaAuthMobils();
  handleErrors('authMobils',error)

  /*
  if(props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("BATXLOE"))
  {
    error.authPortatils = validaAuthPortatils();
    handleErrors('authPortatils',error)

  }
  */

  if( authLlibresSocialitzatsCriteria )
  {
    error.authLlibresSocialitzats = validaAuthLlibresSocialitzats();
    handleErrors('authLlibresSocialitzats',error)
  }

  error.authGDPR = validaAuthGDPR();
  handleErrors('authGDPR',error)

  error.authResponsable = validaAuthResponsable();
  handleErrors('authResponsable',error)

  error.authDretsImatge = validaAuthDretsImatge();
  handleErrors('authDretsImatge',error)

  if( authAlcoholCriteria ) {
    error.authAlcohol = validaAuthAlcohol();
    handleErrors('authAlcohol',error)
  }

  if( authMedicaCriteria ) {
  error.authMedica = validaAuthMedica();
  handleErrors('authAlcohol',error)
  }

  if( !major18 ) {
    error.authSortides = validaAuthSortides();
    handleErrors('authSortides',error)
  }

  error.authPagament = validaAuthPagament();
  handleErrors('authPagament',error)

  setErrors(error)

  let noError = true;
  //DEVELOP 
  if(!config.develop) // bypass errors if develop == true
  {
    Object.keys(error).forEach( (k) => { if(error[k] !== null) noError = false } )
  }

  //console.log('ERROR',error);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}

  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">


                                {major16 ? (
                                  <AuthCompromis auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} />
                                ) : (
                                  <AuthCompromisMenors16 auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} />
                                )
                                }

                                {/* AUTORITZACIO ESPECIFICA ESO */}
                                {(props.dadesEstudis.curs.id.startsWith("ESOLOE")) ?
                                  <AuthMobilsESO auth={authMobils} handleChange={handleChangeMobils} error={errors.authMobils} />
                                  :
                                  <AuthMobils auth={authMobils} handleChange={handleChangeMobils} error={errors.authMobils} />
                                }

                                { authLlibresSocialitzatsCriteria && 
                                  <AuthLlibresSocialitzats auth={authLlibresSocialitzats} handleChange={handleChangeLlibresSocialitzats} error={errors.authLlibresSocialitzats} />
                                }

                                <AuthDretsImatge auth={authDretsImatge} handleChange={handleChangeAuthDretsImatge} error={errors.authDretsImatge} major18={major18} /> <br />

                                { major18 ? 
                                  <AuthSortides auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                 : 
                                  <AuthSortidesMenors auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                }

                                { authAlcoholCriteria && <AuthAlcohol auth={authAlcohol} handleChange={handleChangeAlcohol} errors={errors.authAlcohol} /> }

                                { authMedicaCriteria && <AuthMedica auth={authMedica} handleChange={handleChangeMedica} errors={errors.authMedica} /> }

                                <AuthAMPA auth={authAMPA} handleChange={handleChangeAMPA} error={errors.authAMPA} /> 

                                <AuthPagament auth={authPagament} handleChange={handleChangePagament} error={errors.authPagament} />

                                <AuthGDPR auth={authGDPR} handleChange={handleChangeGDPR} error={errors.authGDPR} />

                                <AuthResponsable auth={authResponsable} handleChange={handleChangeResponsable} error={errors.authResponsable} /> 

                                <AuthEdat17 edat={props.dadesPersonals.edat} /> 

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>












                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}